module.exports = __webpack_public_path__ + "1819b7385f91b64f44165cd3b6584ad6.svg";